export default "__VITE_ASSET__CCWtaoQ6__"